"use strict";

/**
 * Перевод названий месяцев и дней недели для календарей.
 * Пока непонятно, в каком объёме нужна будет мультиязычная поддержка, поэтому
 * реализуем самый простой вариант
 */
(function(){
var self = Fotobook.intl = {
    "data" : {},
    "defaultLocale" : "en",
    "setData" : function(data){
        this.data = data;
    },
    "get" : function(element, locale, type, style){
        var object = this.data[type][style][element];
        return object[locale] || object[this.defaultLocale];
    },
};

$(document).on("UPDATE-CALENDAR-INTL", function(event, data){
    self.setData(data);
})

})();